var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7066D69C-C3FF-4305-9F12-CED7B180566A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.0002,11 L22.0002,11 L22.0002,13 L13.0002,13 L13.0002,22 L11.0002,22 L11.0002,13 L2.0002,13 L2.0002,11 L11.0002,11 L11.0002,2 L13.0002,2 L13.0002,11 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile-no-data",
    transform: "translate(-182.000000, -2301.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-Info",
    transform: "translate(100.000000, 471.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "languages-",
    transform: "translate(0.000000, 1690.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add",
    transform: "translate(62.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_plus",
    transform: "translate(18.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#191919",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlus);
export default __webpack_public_path__ + "static/media/ico_plus.55bfaf258bd6f7c94892a8c9a83fb3a3.svg";
export { ForwardRef as ReactComponent };